import { Maybe } from 'types/graphqlTypes'

const TRIMMED_FACILITY_UUID_LENGTH = 6

export const getTrimmedUuid = (uuid: Maybe<string>) => {
  if (!uuid) return ''
  return uuid.substring(uuid.length - TRIMMED_FACILITY_UUID_LENGTH)
}
